module.exports = __webpack_public_path__ + "static/wky_devices.aa602d18.png";